import React, { useCallback, useEffect, useState } from 'react';
import AsyncSelect from '../../components/AsyncSelect';
import { Controller, useFormContext } from "react-hook-form";
import { BasicDataTypes } from '../../types/types';
import { useLocationRequest } from '../../hooks/locationRequest';
import { useAppSelector } from '../../hooks';
const debounce = require('lodash.debounce');

interface SelectDataProps {
  // setOption: React.Dispatch<React.SetStateAction<BasicDataTypes | null>>;
  error: string | undefined;
}

const LocationSelect: React.FC<SelectDataProps> = ({ error }) => {
  const { control } = useFormContext();
  const [ searchText, setSearchText ] = useState<string>("");
  const [ resultData, setResultData ] = useState<BasicDataTypes[]>([]);
  const locationRequest = useLocationRequest();
  const { loading } = useAppSelector(state=> state.location)

  const fetchData = useCallback(async (query: string) => {
    try {
      const response = await locationRequest({ method: 'GET', data: null, slug: null, query: query });
      const data = response.payload.data;      
      setResultData(data || []);
    } catch (error) {
      console.error('Failed to fetch visa:', error);
    }
  }, [locationRequest]);

  const debouncedFetchData = useCallback(
    debounce((searchQuery: string) => fetchData(searchQuery), 300),
    [fetchData]
  );

  useEffect(() => {
    if (searchText !== "") {
      debouncedFetchData(searchText);
    } else {
      debouncedFetchData(null);
    }
    return () => debouncedFetchData.cancel();
  }, [debouncedFetchData, searchText]);

  return (
    <Controller
      name="location"
      control={control}
      render={({ field }) => (
        <AsyncSelect
          selectedOption={field.value || null}
          options={resultData}
          setSelectedOption={field.onChange}
          placeholder="Select Location"
          error={error}
          setSearchText={setSearchText}
          loading={loading}
        />
      )}
    />
  );
};

export default React.memo(LocationSelect);
